module.exports = __webpack_public_path__ + "static/media/component-9.17821b0d.svg";